export default __webpack_public_path__ + "static/EXP_Pressemeldung_1_1_en-ba457e603f70f7fc0f28395845b8546e.png";